<template>
  <div>
    <div class="form-group row mb-4">
      <label class="col-form-label col-lg-2">ชื่อหน่วย</label>
      <label class="col-form-label col-lg-8"
        ><span class="badge-lang">TH</span>{{ viewComponentModel.display_name.th }}</label
      >
    </div>
    <div class="form-group row mb-4" v-if="viewComponentModel.display_name">
      <label class="col-form-label col-lg-2"></label>
      <label class="col-form-label col-lg-8"
        ><span class="badge-lang">EN</span>{{ viewComponentModel.display_name.en }}</label
      >
    </div>
    <div class="form-group row mb-4" v-if="viewComponentModel.display_name">
      <label class="col-form-label col-lg-2">ชื่อหน่วยแบบสั้น</label>
      <label class="col-form-label col-lg-8">{{ viewComponentModel.short_name.en }}</label>
    </div>
    <div class="form-group row mb-4">
      <label class="col-form-label col-lg-2">สถานะ</label> 
      <label class="col-form-label col-lg-8">
        <label :class="`label label-${statusLabel}`">
          {{ viewComponentModel.status }}
        </label>
      </label>
    </div>
  </div>
</template>

<script>
import { StatusEnum } from '@/enum/status.enum.js'

export default {
  name: 'UnitDetailView',
  components: {},
  props: {
    value: {
      type: Object,
      default: () => {
        return this.viewComponentModel
      },
    },
  },
  mounted() {},
  computed: {
    statusLabel() {
      return this.viewComponentModel !== null 
              && this.viewComponentModel.status !== ''
              ? this.viewComponentModel.status.toLowerCase()
              : ''
    }
  },
  data() {
    return {
      viewComponentModel: {
        id: null,
        display_name: {
          th: '',
          en: '',
        },
        short_name: { th: '', en: '' },
        status: StatusEnum.ACTIVE,
      },
    }
  },
  created: function() {
    if (this.value) this.viewComponentModel = this.value
  },
  watch: {
    value: {
      handler(val) {
        this.viewComponentModel = val
      },
      deep: true,
    },
  },
  methods: {},
}
</script>
